<template>
  <div id="joinPopup" class="join_st">
    <!-- 본인 인증 START-->
    <div class="images_wrap none">
      <router-link
        :to="{ name: 'store' }"
        class="an_a"
        aria-lable="e-alice 홈으로 이동"
      >
        <span class="svg_alice_b"></span>
        <span class="an_t">{{ $t('views.auth.join.authphone.ealice') }}</span>
      </router-link>
    </div>
    <div class="section full">
      <div class="inner flex">
        <div class="box_wrap" data-detail="id_search">
          <div class="box">
            <div class="box_title">
              <h2>{{ $t('views.auth.join.authphone.8052') }}</h2>
              <!-- <p class="guide_txt">{{ $t('views.auth.join.authphone.2541') }}</p> -->
            </div>

            <ul class="form_wrap">
              <li class="input_wrap num_auth">
                <label for="number" class="hidden">휴대폰번호</label>
                <input
                  id="number"
                  type="number"
                  class="input_t w-100"
                  name="emailAuth"
                  :placeholder="$t('views.auth.join.authphone.2960')"
                />
                <div class="btn_wrap">
                  <a class="box_btn dull" @click="requestPhoneCode">
                    <!-- 인증번호 불일치 시 알럿창 -->
                    <span class="an_t">{{
                      $t('views.auth.join.authphone.3915')
                    }}</span>
                  </a>
                </div>
              </li>
              <li class="input_wrap time_count">
                <label for="code" class="hidden">인증번호</label>
                <input
                  id="code"
                  type="text"
                  class="input_t w-100"
                  name="authCode"
                  :placeholder="$t('views.auth.join.authphone.4560')"
                />
                <span class="count">{{
                  $t('views.auth.join.authphone.9528')
                }}</span>
              </li>
              <li class="btn_wrap">
                <a class="box_btn w-100" @click="verifyAuthCode">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthPhone',

  methods: {
    requestPhoneCode() {
      // TODO: add API code for phone auth request
    },
    verifyAuthCode() {
      this.$router.push({ name: 'join_step3' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
